// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xtpT","messages":"styles_messages__JQ7_a"};